export default __webpack_public_path__ + "static/TSD_Meltwater_Graphs_Hero-a9bfe7a618b68b8ff8236b6441c6b016.png";